export default __webpack_public_path__ + "media/flags/by-245578c1.svg";